<template>
    <div>
        <hts-tooltip>
            <span>
                {{ CRequest }}
            </span>
            <template #reference>
                {{ CRequest }}
            </template>
        </hts-tooltip>
    </div>
</template>

<script lang="ts" setup>
const { $formatters } = useNuxtApp()

const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CRequest = computed(() => {
  const { request } = params?.value?.data?.orderData || {}
  return request
})

// const CDeadline = computed(() => {
//   const { positions } = params?.value?.data
//   if (!positions) {
//     return []
//   }

//   const tasks = positions[positions.length - 1].tasks
//   if (!tasks) {
//     return []
//   }

//   const results = [] as string[]

//   tasks.forEach((t: any) => {
//     const times = [] as string[]
//     t.timeConditions.forEach((tc: any) => {
//       if (tc.timeType === 'LATEST') {
//         times.push($formatters.datetime(tc.time, 'DD/MM/YYYY h:mm A'))
//       }
//     })

//     if (times.length) {
//       results.push(`${t.taskName} - ${times.join(', ')}`)
//     }
//   })

//   return results
// })
</script>

<style scoped></style>
